var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 0.125H21.125C21.9883 0.125 22.75 0.886719 22.75 1.75V8.25C22.75 9.16406 21.9883 9.875 21.125 9.875C20.2109 9.875 19.5 9.16406 19.5 8.25V5.71094L13.6602 11.5L19.5 17.3398V14.75C19.5 13.8867 20.2109 13.125 21.125 13.125C21.9883 13.125 22.75 13.8867 22.75 14.75V21.25C22.75 22.1641 21.9883 22.875 21.125 22.875H14.625C13.7109 22.875 13 22.1641 13 21.25C13 20.3867 13.7109 19.625 14.625 19.625H17.1641L11.375 13.8359L5.53516 19.625H8.125C8.98828 19.625 9.75 20.3867 9.75 21.25C9.75 22.1641 8.98828 22.875 8.125 22.875H1.625C0.710938 22.875 0 22.1641 0 21.25V14.75C0 13.8867 0.710938 13.125 1.625 13.125C2.48828 13.125 3.25 13.8867 3.25 14.75V17.3398L9.03906 11.5L3.25 5.71094V8.25C3.25 9.16406 2.48828 9.875 1.625 9.875C0.710938 9.875 0 9.16406 0 8.25V1.75C0 0.886719 0.710938 0.125 1.625 0.125H8.125C8.98828 0.125 9.75 0.886719 9.75 1.75C9.75 2.66406 8.98828 3.375 8.125 3.375H5.53516L11.375 9.21484L17.1641 3.375H14.625C13.7109 3.375 13 2.66406 13 1.75C13 0.886719 13.7109 0.125 14.625 0.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowExtend);
export default __webpack_public_path__ + "static/media/arrow_extend.b78222b013c333d59649ef1599231aa0.svg";
export { ForwardRef as ReactComponent };